"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ownable2Step__factory = exports.Ownable__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var Ownable__factory_1 = require("./Ownable__factory");
Object.defineProperty(exports, "Ownable__factory", { enumerable: true, get: function () { return Ownable__factory_1.Ownable__factory; } });
var Ownable2Step__factory_1 = require("./Ownable2Step__factory");
Object.defineProperty(exports, "Ownable2Step__factory", { enumerable: true, get: function () { return Ownable2Step__factory_1.Ownable2Step__factory; } });
